module.exports = __webpack_public_path__ + "static/img/wealth_level_81.12e0fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_81.png
// module id = Bg2k
// module chunks = 0